import {updateBy} from 'src/utils/array';

import {familyCollection, familyReferences, barecodeRef} from 'src/constant/firestore';
import {firestore} from "../../config/firebaseConfig";


export const addFamily = (data, callback) => {
    return async () => {
        try {

            const snap = await familyCollection
                .where('count', '<', 400)
                .limit(1)
                .get();

            if (snap.empty) {
                const records = [data];
                const ids = records?.map(one => one?.id);
                const count = ids.length;

                await familyCollection.add({
                    records,
                    ids,
                    count,
                    createdAt: new Date()
                });
            } else {

                await firestore.runTransaction(transaction => {
                    const ref = familyCollection.doc(snap.docs[0]?.id);
                    return transaction.get(ref).then(doc => {
                        if (doc.exists) {

                            const document = {id: doc.id, ...doc.data()};
                            const records = [...document?.records, data];
                            const ids = records?.map(one => one?.id);
                            const count = ids.length;

                            transaction.set(ref, {
                                records,
                                ids,
                                count,
                                updatedAt: new Date()
                            }, {merge: true});
                        }
                    });
                });

            }

            callback && callback();

        } catch (error) {
            console.error(error);
        }
    };
};

export const updateFamily = (data, callback) => {
    return async (dispatch) => {
        try {
            const snap = await familyCollection
                .where('ids', 'array-contains', data?.id)
                .limit(1)
                .get();

            if (!snap.empty) {


                await firestore.runTransaction(transaction => {
                    const ref = familyCollection.doc(snap.docs[0]?.id);
                    return transaction.get(ref).then(doc => {
                        if (doc.exists) {

                            const document = {id: doc.id, ...doc.data()};
                            const records = updateBy(document?.records || [], data);
                            const ids = records?.map((one) => one?.id);
                            const count = ids.length;

                            transaction.set(ref, {
                                records,
                                ids,
                                count,
                                updatedAt: new Date()
                            }, {merge: true});
                        }
                    });
                });

                callback && callback();

            } else {
                dispatch(addFamily(data, callback));
            }

        } catch (error) {
            console.error(error);
        }
    };
};

export const deleteFamily = (id, callback) => {
    return async () => {
        try {
            const snap = await familyCollection
                .where('ids', 'array-contains', id)
                .limit(1)
                .get();

            if (!snap.empty) {

                await firestore.runTransaction(transaction => {
                    const ref = familyCollection.doc(snap.docs[0]?.id);
                    return transaction.get(ref).then(doc => {
                        if (doc.exists) {

                            const document = {id: doc.id, ...doc.data()};
                            const records = (document?.records || [])?.filter(one => one?.id !== id);
                            const ids = records?.map((one) => one?.id);
                            const count = ids.length;

                            transaction.set(ref, {
                                records,
                                ids,
                                count,
                                updatedAt: new Date()
                            }, {merge: true});
                        }
                    });
                });


            }

            callback && callback();

        } catch (error) {
            console.error(error);
        }
    };
};

export const reserveCode = (callback) => {
    return async () => {
        try {

            await firestore.runTransaction(transaction => {
                return transaction.get(familyReferences).then(doc => {

                    if (doc.exists) {

                        const prev = doc.data()?.ucp || 1
                        const ucp = prev + 1

                        callback && callback(`DSF${'0'?.repeat(6 - String(ucp).length)}${ucp}`)

                        transaction.set(familyReferences, {
                            ucp
                        }, {merge: true})

                    }

                })

            })

        } catch (e) {
            console.error(e)
        }
    }
}


export const reserveUPC = (callback) => {
    return async () => {
        try {

            await firestore.runTransaction(transaction => {
                return transaction.get(barecodeRef).then(doc => {

                    if (doc.exists) {

                        const prev = doc.data()?.upc || 1
                        const upc = prev + 1

                        callback && callback(`DS${'0'?.repeat(7 - String(upc).length)}${upc}`)

                        transaction.set(barecodeRef, {
                            upc
                        }, {merge: true})

                    }

                })

            })

        } catch (e) {
            console.error(e)
        }
    }
}